module.exports = __webpack_public_path__ + "static/media/matching-score-rank-9.439455d6.png";